// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"HelpVideo_videoContainer__-WCZY","text":"HelpVideo_text__2y5C_"};